(() => {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const abort = new AbortController();
    const listen = (node, event, fn) => node?.addEventListener(event, fn, { signal: abort.signal });
    const base = window.Shopify?.routes?.root || '/';
    const money = cents => new Intl.NumberFormat('es-MX', {
      style: 'currency', currency: root.dataset.currency || 'MXN',
    }).format(cents / 100);
    let busy = false;
    let revision = 0;
    let refreshTimer;
    let barFrame;
    let lastCart;
    const bar = root.querySelector('[data-fp-cartbar]');
    const preferencesAllowed = () => window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true;

    function species(next) {
      next = next === 'gato' ? 'gato' : 'perro';
      root.querySelectorAll('[data-fp-species]').forEach(el => {
        const active = el.dataset.fpSpecies === next;
        el.classList.toggle('is-active', active);
        if (active) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });
      root.querySelectorAll('[data-species-panel],[data-species-text]').forEach(el => {
        el.classList.toggle('is-active', (el.dataset.speciesPanel || el.dataset.speciesText) === next);
      });
      root.querySelectorAll('[data-fp-species-link]').forEach(el => { el.href = el.dataset[`${next}Url`]; });
    }
    root.querySelectorAll('[data-fp-species]').forEach(el => listen(el, 'click', event => {
      event.preventDefault();
      species(el.dataset.fpSpecies);
      if (preferencesAllowed()) {
        try { localStorage.setItem('fp_all_sp', el.dataset.fpSpecies); } catch {}
      }
    }));
    if (preferencesAllowed()) {
      try { species(localStorage.getItem('fp_all_sp')); } catch {}
    }

    function paintZip(state) {
      const zip = /^\d{5}$/.test(state?.zip || '') ? state.zip : '';
      const express = zip && state.isExpress === true;
      root.querySelector('[data-fp-cp-trigger]').classList.toggle('is-express', !!express);
      root.querySelector('[data-fp-cp-title]').textContent = zip
        ? (express ? '⚡ Te llega hoy en 120 min' : 'Te llega en 2 a 4 días')
        : '¿Te llega hoy? Escribe tu CP';
      root.querySelector('[data-fp-cp-sub]').textContent = zip
        ? `CP ${zip}${express ? ' · Pide antes de las 2 pm' : ' · Envío gratis desde $499'}`
        : 'En Guadalajara llegamos en 120 min. Enviamos a todo México.';
      root.querySelector('[data-fp-cp-cta]').textContent = zip ? 'Cambiar' : 'Ingresar CP';
    }
    try {
      paintZip({ zip: localStorage.getItem('fp_user_zip'), isExpress: localStorage.getItem('fp_user_zip_express') === 'true' });
    } catch { paintZip({}); }
    listen(window, 'fp:zip-updated', event => paintZip(event.detail));
    listen(window, 'storage', event => {
      if (!event.key?.startsWith('fp_user_zip')) return;
      try { paintZip({ zip: localStorage.getItem('fp_user_zip'), isExpress: localStorage.getItem('fp_user_zip_express') === 'true' }); } catch {}
    });
    // The existing ZIP module owns coverage and persistence; the Home is only an opener.
    listen(root.querySelector('[data-fp-cp-trigger]'), 'click', event => {
      const opener = [...document.querySelectorAll('[data-fp-open-global-zip-modal]')].find(el => !root.contains(el));
      if (opener && document.querySelector('[data-fp-global-zip-modal][data-fp-global-bound="true"]')) {
        event.preventDefault();
        opener.click();
      }
    });

    root.querySelectorAll('[data-fp-card-variant]').forEach(select => {
      listen(select, 'invalid', event => {
        event.preventDefault();
        const card = select.closest('[data-fp-product]');
        const status = card.querySelector('[data-fp-add-status]');
        select.setAttribute('aria-invalid', 'true');
        select.setAttribute('aria-describedby', status.id);
        status.setAttribute('aria-live', 'off');
        status.dataset.fpError = 'variant';
        status.textContent = 'Elige una presentación para continuar.';
        select.focus();
      });
      listen(select, 'change', () => {
        const option = select.selectedOptions[0];
        const card = select.closest('[data-fp-product]');
        const status = card.querySelector('[data-fp-add-status]');
        if (status.dataset.fpError === 'variant') {
          status.textContent = '';
          delete status.dataset.fpError;
          status.removeAttribute('aria-live');
          select.removeAttribute('aria-invalid');
          select.removeAttribute('aria-describedby');
        }
        if (!option.value) return;
        card.querySelector('[data-fp-product-price]').textContent = option.dataset.money;
        card.querySelector('[name="quantity"]').value = option.dataset.min;
        card.querySelectorAll('[data-fp-product-link]').forEach(a => { a.href = option.dataset.url; });
        const img = card.querySelector('.fp-home-normal-v4__product-image');
        if (img && option.dataset.image) {
          img.removeAttribute('srcset');
          img.src = option.dataset.image;
        }
        status.textContent = '';
      });
    });
    root.querySelectorAll('[data-fp-ap-tab]').forEach(button => listen(button, 'click', () => {
      const group = button.closest('[data-fp-ap-species]');
      group.querySelectorAll('[data-fp-ap-tab]').forEach(tab => {
        const active = tab === button;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-pressed', String(active));
      });
      group.querySelectorAll('[data-fp-ap-panel]').forEach(panel => { panel.hidden = panel.dataset.fpApPanel !== button.dataset.fpApTab; });
    }));

    function steps(variant) {
      const rule = variant?.volume;
      const raw = rule?.discountData?.discountSteps;
      if (!Array.isArray(raw) || rule.advancedOptions?.length ||
          rule.discountData.discountProductCombination !== 'ANY_COMBINATION') return [{ quantity: 1, rate: 1 }];
      const tiers = raw.map(t => ({
        quantity: Number(t.minProductCount),
        rate: t.discountType === 'EMPTY' ? 1 : Number(t.discountAmount),
        valid: ['EMPTY', 'RELATIVE_DECREASE'].includes(t.discountType) && t.unitDiscont === 1,
      }));
      if (!tiers.length || tiers.some(t => !t.valid || !Number.isSafeInteger(t.quantity) ||
          t.quantity < 1 || t.quantity > 100 || t.rate <= 0 || t.rate > 1)) return [{ quantity: 1, rate: 1 }];
      return tiers.sort((a, b) => a.quantity - b.quantity);
    }
    root.querySelectorAll('[data-fp-antipulgas]').forEach(form => {
      const variants = JSON.parse(form.querySelector('[data-fp-ap-data]').textContent);
      const select = form.querySelector('[name="id"]');
      const fieldset = form.querySelector('[data-fp-tiers]');
      const render = () => {
        const selected = variants.find(v => String(v.id) === select.value);
        const variant = selected || variants.find(v => v.available) || variants[0];
        const previous = Number(form.querySelector('[name="quantity"]:checked')?.value || 1);
        fieldset.querySelectorAll('label').forEach(el => el.remove());
        const tiers = steps(variant);
        tiers.forEach((tier, index) => {
          const label = document.createElement('label');
          label.className = 'fp-home-normal-v4__tier';
          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = 'quantity';
          radio.value = String(tier.quantity);
          radio.checked = tiers.some(t => t.quantity === previous) ? tier.quantity === previous : index === 0;
          radio.disabled = tier.quantity < variant.min || (tier.quantity - variant.min) % variant.increment !== 0 ||
            (variant.max != null && tier.quantity > variant.max);
          label.append(radio);
          const unit = Math.round(variant.price * tier.rate);
          const savings = (variant.price - unit) * tier.quantity;
          for (const [cls, text] of [
            ['title', `${tier.quantity} ${tier.quantity === 1 ? 'caja' : 'cajas'}`],
            ['price', `${selected ? '' : 'Desde '}${money(unit)} c/u`],
            ['save', savings > 0 ? `Ahorras ${money(savings)}` : 'Precio normal'],
          ]) {
            const span = document.createElement('span');
            span.className = `fp-home-normal-v4__tier-${cls}`;
            span.textContent = text;
            label.append(span);
          }
          fieldset.append(label);
        });
      };
      listen(select, 'change', render);
      render();
    });

    function positionBar() {
      let offset = 0;
      document.querySelectorAll('#PBarNextFrameWrapper,#preview-bar-iframe,#ShopifyPreviewBar').forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.height > 0 && r.height < 180 && r.bottom >= innerHeight - 2) offset = Math.max(offset, innerHeight - r.top);
      });
      const bottom = `${offset}px`;
      if (bar.style.bottom !== bottom) bar.style.bottom = bottom;
      const covered = document.documentElement.classList.contains('fp-zip-modal-open') ||
        /side_Drawer_open|side_drawer_open|quickview-open/.test(document.body.className);
      if (bar.hidden !== covered) bar.hidden = covered;
      const space = `${bar.classList.contains('is-visible') && !covered ? bar.offsetHeight + offset : 0}px`;
      // Avoid invalidating the whole Home when observer notifications change no geometry.
      if (root.style.getPropertyValue('--fp-home-cart-space') !== space) {
        root.style.setProperty('--fp-home-cart-space', space);
      }
    }
    function schedulePositionBar() {
      if (barFrame) return;
      barFrame = requestAnimationFrame(() => {
        barFrame = null;
        positionBar();
      });
    }
    function renderCart(cart) {
      if (!Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) throw new Error('Invalid cart');
      lastCart = cart;
      root.dataset.currency = cart.currency;
      bar.classList.toggle('is-visible', cart.item_count > 0);
      root.querySelector('[data-fp-cart-total]').textContent = money(cart.total_price);
      const left = Math.max(0, 49900 - cart.total_price);
      root.querySelector('[data-fp-ship-text]').textContent = left > 0
        ? `Te faltan ${money(left)} para envío gratis`
        : '✓ ¡Tienes envío gratis!';
      document.querySelectorAll('.fp2-cart').forEach(anchor => {
        let badge = anchor.querySelector('.fp2-cart__badge');
        if (!badge && cart.item_count) {
          badge = document.createElement('span');
          badge.className = 'fp2-cart__badge';
          anchor.append(badge);
        }
        if (badge) { badge.hidden = !cart.item_count; badge.textContent = String(cart.item_count); }
      });
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        if (el.textContent !== String(cart.item_count)) el.textContent = String(cart.item_count);
        el.hidden = !cart.item_count;
      });
      positionBar();
    }
    async function refresh() {
      const version = ++revision;
      const res = await fetch(`${base}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!res.ok) throw new Error('Cart unavailable');
      const cart = await res.json();
      if (version === revision) renderCart(cart);
      return cart;
    }
    function scheduleRefresh() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => { if (!busy) refresh().catch(() => {}); }, 120);
    }
    listen(root, 'submit', async event => {
      const form = event.target.closest('[data-fp-home-add]');
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      if (busy || form.dataset.uncertain || !form.reportValidity()) return;
      const container = form.closest('[data-fp-product]');
      const status = container.querySelector('[data-fp-add-status]');
      const button = event.submitter;
      const original = button?.textContent;
      const data = new FormData(form);
      const id = Number(data.get('id'));
      const quantity = Number(data.get('quantity'));
      if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity < 1) return;
      busy = true;
      ++revision;
      if (button) { button.disabled = true; button.textContent = original === '+' ? '…' : 'Agregando...'; }
      status.textContent = 'Agregando al carrito...';
      let confirmed = false;
      let rejected = false;
      try {
        const res = await fetch(`${base}cart/add.js`, {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity }] }),
        });
        const result = await res.json();
        if (!res.ok) {
          rejected = res.status >= 400 && res.status < 500;
          throw new Error(rejected ? (result.description || 'No se pudo agregar esta cantidad. Revisa la disponibilidad.') : 'Respuesta no confirmada');
        }
        confirmed = true;
        status.textContent = 'Agregado a tu carrito.';
        await refresh();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: lastCart, source: 'fp-home-normal-v4' } }));
      } catch (error) {
        if (confirmed) status.textContent = 'Producto agregado. Abre tu carrito para consultar el total.';
        else if (rejected) { status.textContent = error.message; await refresh().catch(() => {}); }
        else {
          // Never retry an uncertain POST: Shopify may already have added the item.
          form.dataset.uncertain = 'true';
          status.textContent = 'No pudimos confirmar la respuesta. Revisa tu carrito antes de volver a agregar.';
          await refresh().catch(() => {});
        }
      } finally {
        busy = false;
        if (button) { button.disabled = !!form.dataset.uncertain; button.textContent = original; }
      }
    });
    listen(window, 'pageshow', scheduleRefresh);
    listen(document, 'visibilitychange', () => { if (!document.hidden) scheduleRefresh(); });
    listen(document, 'cart:updated', event => { if (event.detail?.source !== 'fp-home-normal-v4') scheduleRefresh(); });
    listen(window, 'resize', schedulePositionBar);
    const observer = new MutationObserver(schedulePositionBar);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    const resize = new ResizeObserver(schedulePositionBar);
    resize.observe(bar);
    const toolbar = document.getElementById('PBarNextFrameWrapper');
    if (toolbar) resize.observe(toolbar);
    const ajaxComplete = (_event, _xhr, settings) => {
      if (/\/cart\/(?:add|change|update|clear)(?:\.js|\.json)?(?:\?|$)/.test(settings.url)) scheduleRefresh();
    };
    let jqueryBound = false;
    let unsubscribe;
    function bindCartEvents() {
      if (!jqueryBound && window.jQuery) {
        window.jQuery(document).on('ajaxComplete.fpHomeNormalV4', ajaxComplete);
        jqueryBound = true;
      }
      if (!unsubscribe && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleRefresh);
      }
    }
    bindCartEvents();
    listen(document, 'DOMContentLoaded', bindCartEvents);
    listen(window, 'load', bindCartEvents);
    // Revie remains the source and full viewer; the compact cards use its public text.
    const slot = root.querySelector('[data-fp-reviews-slot]');
    const reviews = document.querySelector('.shopify-section[id$="__171790875055d5a4dc"]');
    const originalParent = reviews?.parentNode;
    const originalNext = reviews?.nextSibling;
    let reviewObserver;
    if (reviews && slot) {
      const details = slot.querySelector('[data-fp-all-reviews]');
      slot.querySelector('[data-fp-review-original]').append(reviews);
      details.hidden = false;
      root.querySelector('[data-fp-reviews-fallback]').hidden = true;
      const showSummary = () => {
        const header = reviews.querySelector('.topTest');
        const rating = Number.parseFloat(header?.querySelector('.titleRevie')?.getAttribute('title'));
        const count = Number(header?.querySelector('div')?.textContent.replace(/[^\d]/g, ''));
        const entries = [...reviews.querySelectorAll('#revieListTestimoniales .p-test')].slice(0, 3);
        if (!Number.isFinite(rating) || rating < 0 || rating > 5 || !count || entries.length !== 3 ||
            entries.some(el => !el.querySelector('.tm-rev-com')?.textContent.trim() || !el.dataset.name ||
              !Number.isFinite(Number(el.dataset.stars)) || Number(el.dataset.stars) < 0 || Number(el.dataset.stars) > 5)) return;
        const cards = entries.map(entry => {
          const card = document.createElement('article');
          card.className = 'fp-home-normal-v4__review';
          const stars = document.createElement('span');
          stars.className = 'fp-home-normal-v4__stars';
          const value = Number(entry.dataset.stars);
          stars.textContent = '\u2605'.repeat(Math.round(value)) + '\u2606'.repeat(5 - Math.round(value));
          stars.setAttribute('aria-label', `${value} de 5 estrellas`);
          const text = document.createElement('blockquote');
          text.className = 'fp-home-normal-v4__review-text';
          text.textContent = entry.querySelector('.tm-rev-com').textContent;
          const name = document.createElement('span');
          name.className = 'fp-home-normal-v4__review-who';
          name.textContent = entry.dataset.name;
          card.append(stars, text, name);
          return card;
        });
        slot.querySelector('[data-fp-review-cards]').replaceChildren(...cards);
        const score = slot.querySelector('[data-fp-review-score]');
        score.textContent = rating.toFixed(2);
        score.setAttribute('aria-label', `${rating} de 5 estrellas`);
        slot.querySelector('[data-fp-review-stars]').style.setProperty('--fp-rating', `${rating / 5 * 100}%`);
        slot.querySelector('[data-fp-review-count]').textContent = `${count.toLocaleString('es-MX')} opiniones de clientes`;
        slot.querySelector('[data-fp-review-summary]').hidden = false;
        // Leave all original reviews and their pagination available in the disclosure.
        details.open = false;
        reviewObserver?.disconnect();
      };
      reviewObserver = new MutationObserver(showSummary);
      reviewObserver.observe(reviews, { childList: true, subtree: true, characterData: true });
      showSummary();
      listen(details, 'toggle', () => {
        if (details.open) window.dispatchEvent(new Event('resize'));
      });
    }
    listen(document, 'shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      if (reviews && originalParent) originalParent.insertBefore(reviews, originalNext?.parentNode === originalParent ? originalNext : null);
      abort.abort();
      observer.disconnect();
      reviewObserver?.disconnect();
      resize.disconnect();
      if (barFrame) cancelAnimationFrame(barFrame);
      clearTimeout(refreshTimer);
      unsubscribe?.();
      window.jQuery?.(document).off('ajaxComplete.fpHomeNormalV4', ajaxComplete);
    });
    refresh().catch(() => {});
    positionBar();
  }
  document.querySelectorAll('[data-fp-home-normal-v4]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-fp-home-normal-v4]').forEach(init));
})();
